// Heuristic MVEL variable detection: finds identifier-like tokens in a formula
// string and filters out the n()/b()/s()/Math helpers, common keywords, and
// dotted member-access targets (e.g. the "round" in "Math.round(x)"), which
// aren't themselves top-level data-map keys.
const RESERVED_TOKENS = new Set([
  'n', 'b', 's', 'Math',
  'true', 'false', 'null', 'nil', 'empty',
  'and', 'or', 'not', 'new', 'instanceof', 'this',
  'if', 'else', 'for', 'while', 'return',
  'PI', 'E', 'round', 'min', 'max', 'abs', 'floor', 'ceil', 'pow', 'sqrt', 'sin', 'cos', 'tan', 'log', 'exp'
]);

export function detectFormulaVariables(formula: string): string[] {
  if (!formula) {
    return [];
  }

  // Strip string literals so words inside quotes aren't picked up as variables.
  const stripped = formula
    .replace(/'(?:[^'\\]|\\.)*'/g, ' ')
    .replace(/"(?:[^"\\]|\\.)*"/g, ' ');

  const tokenPattern = /[A-Za-z_][A-Za-z0-9_]*/g;
  const found = new Set<string>();
  let match: RegExpExecArray | null;
  // tslint:disable-next-line:no-conditional-assignment
  while ((match = tokenPattern.exec(stripped)) !== null) {
    const token = match[0];
    const precedingChar = stripped.charAt(match.index - 1);
    if (precedingChar === '.' || RESERVED_TOKENS.has(token)) {
      continue;
    }
    found.add(token);
  }

  return Array.from(found).sort();
}

export function buildInputJsonFromFormula(formula: string, existingJson: string): string {
  const variables = detectFormulaVariables(formula);
  let existing: any = {};
  if (existingJson && existingJson.trim()) {
    try {
      existing = JSON.parse(existingJson);
    } catch (e) {
      existing = {};
    }
  }
  // Rebuild keyed only by the detected variables: stale keys from a previous
  // formula are dropped, values already typed for still-present keys survive.
  const result: any = {};
  variables.forEach(v => {
    result[v] = (v in existing) ? existing[v] : '';
  });
  return JSON.stringify(result, null, 2);
}
